import Produit from "./Produit";
import {coefsByFormat} from "../data/Formats"

export default class ProduitEcranCible extends Produit {

  constructor(code, libelle, audienceLibelle, valeursParSemaine) {
    super(code, libelle, audienceLibelle, [100], []);
    this.valeursParSemaine = valeursParSemaine;
  }

  tarif(semaine, format = 30) {

    const coefFormat = coefsByFormat[format];
    const tarif = this.valeursParSemaine[semaine.code].tarif * coefFormat;

    return tarif.roundN(10);
  }

  audience(semaine) {

    const audience = this.valeursParSemaine[semaine.code].audience;

    return audience.roundN(1);
  }
}